import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocPermissionsRoute: InvariantJiraRoute = {
	name: 'eoc-permissions',
	path: '/jira/ops/teams/:teamId/settings',
	exact: true,
};
